import React from 'react';
import { Route } from 'react-router-dom';

import { wrapGrid } from 'client/shared/util';
import { MusicLibrary } from 'client/shared/components';

import { BandAccount, Albums, Music, Dashboard } from './artist';
import Photos from './artist/photos/photos';

class AppRoutes extends React.Component {
	render () {
		const {artist, userID} = this.props;
		
		return (
			<section className="main-content" style={{paddingTop:'2vw'}}>
				<Route exact path="/" component={ (props) => <BandAccount userID={userID} artist={artist} {...props} /> } />
				<Route path="/bands/music" render={ (props) => <Music optionsTheme="dark" { ...props } /> } />
				<Route exact path="/bands/albums" component={ wrapGrid(Albums) } />
				<Route exact path="/bands/photos" component={ (props) => <Photos userID={userID}/> } />
				<Route exact path="/bands/dashboard" component={ (props) => <Dashboard artist={ artist } /> } />
				{/* <Route exact path="/fans" component={ wrapGrid(ArtistsList) } /> */}
			</section>
		);
	}
}

export default AppRoutes;